module.exports = __webpack_public_path__ + "static/media/Illus-Birthday@2x.6bca8ed4.png";